import React from 'react'
import todo from '../assets/projects/todo.png'
import ecommerce from '../assets/projects/ecommerce.jpg'
import weather from '../assets/projects/weather.png'
import advise from '../assets/projects/advise.png'
import cloth from '../assets/projects/cloth.png'
import universe from '../assets/projects/universe.png'


const Projects = () => {
  return (
    <div name='projects' className='w-full md:h-screen text-gray-300 my-sm-p bg-[#0a192f]'>
        {/* Container */}
        <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
            <div className='pb-8'>
                <p className='text-4xl fot-bold inline border-b-4 text-gray-3000 border-[#ff914d]'>Projects</p>
                <p className='py-6'>Check out some of my recent projects</p>
            </div>

            <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-4'>
    {/* grid-item */}
                
                {/* 1 */}
                <div style={{ backgroundImage: `url(${todo})` }}
                className='shadow-lg shadow-[#040416] group container rounded-md flex justify-center items-center mx-auto content-div'>
                    {/* hover*/}
                    <div className='opacity-0 group-hover:opacity-100'>
                        <span className='text-2xl font-bold text-white tracking-wider text-center'>
                            Todo Application
                            <p className='text-xl bg-[#ff914d]'>React | Firebase</p>
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="https://todolist-pro.netlify.app/" 
                            target="_blank" rel="noreferrer">
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
                                    Demo
                                </button>
                            </a>
                            <a href="https://github.com/RifadhRFD/react-todo-main" 
                            target="_blank" rel="noreferrer">
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
                                    Code
                                </button>
                            </a>
                        </div>
                    </div>
                </div>

            {/* 2 */}
            <div style={{ backgroundImage: `url(${ecommerce})` }}
                className='shadow-lg shadow-[#040416] group container rounded-md flex justify-center items-center mx-auto content-div'>
                    {/* hover*/}
                    <div className='opacity-0 group-hover:opacity-100'>
                        <span className='text-2xl font-bold text-white tracking-wider text-center'>
                            Electronic Shop
                            <p className='text-xl bg-[#ff914d]'>React</p>
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="https://elctro-mart.netlify.app/" 
                            rel="noreferrer" target="_blank">
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
                                    Demo
                                </button>
                            </a>
                            <a href="https://github.com/RifadhRFD/ecommerce-app-react" 
                            rel="noreferrer" target="_blank">
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
                                    Code
                                </button>
                            </a>
                        </div>
                    </div>
                </div>

                {/* 3 */}
            <div style={{ backgroundImage: `url(${weather})` }}
                className='shadow-lg shadow-[#040416] group container rounded-md flex justify-center items-center mx-auto content-div'>
                    {/* hover*/}
                    <div className='opacity-0 group-hover:opacity-100'>
                        <span className='text-2xl font-bold text-white tracking-wider text-center'>
                            Weather App
                            <p className='text-xl bg-[#ff914d]'>React | API</p>
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="https://cloud-cast.netlify.app/" 
                            rel="noreferrer" target="_blank">
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
                                    Demo
                                </button>
                            </a>
                            <a href="https://github.com/RifadhRFD/weather-app-react" 
                            rel="noreferrer" target="_blank">
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
                                    Code
                                </button>
                            </a>
                        </div>
                    </div>
                </div>

                {/* 4 */}
            <div style={{ backgroundImage: `url(${advise})` }}
                className='shadow-lg shadow-[#040416] group container rounded-md flex justify-center items-center mx-auto content-div'>
                    {/* hover*/}
                    <div className='opacity-0 group-hover:opacity-100'>
                        <span className='text-2xl font-bold text-white tracking-wider text-center'>
                            API Advise App
                            <p className='text-xl bg-[#ff914d]'>React | API</p>
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="https://api-advice.netlify.app/" 
                            rel="noreferrer" target="_blank">
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
                                    Demo
                                </button>
                            </a>
                            <a href="https://github.com/RifadhRFD/react-advise-app" 
                            rel="noreferrer" target="_blank">
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
                                    Code
                                </button>
                            </a>
                        </div>
                    </div>
                </div>

                {/* 5 */}
            <div style={{ backgroundImage: `url(${cloth})` }}
                className='shadow-lg shadow-[#040416] group container rounded-md flex justify-center items-center mx-auto content-div'>
                    {/* hover*/}
                    <div className='opacity-0 group-hover:opacity-100'>
                        <span className='text-2xl font-bold text-white tracking-wider text-center'>
                            Clothing Store
                            <p className='text-xl bg-[#ff914d]'>JavaScript (ES6)</p>
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="https://clothings-co.netlify.app/" 
                            rel="noreferrer" target="_blank">
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
                                    Demo
                                </button>
                            </a>
                            <a href="https://github.com/RifadhRFD/Shopping-Cart" 
                            rel="noreferrer" target="_blank">
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
                                    Code
                                </button>
                            </a>
                        </div>
                    </div>
                </div>

                {/* 6 */}
            <div style={{ backgroundImage: `url(${universe})` }}
                className='shadow-lg shadow-[#040416] group container rounded-md flex justify-center items-center mx-auto content-div'>
                    {/* hover*/}
                    <div className='opacity-0 group-hover:opacity-100'>
                        <span className='text-2xl font-bold text-white tracking-wider text-center'>
                            Universe Parallax
                            <p className='text-xl bg-[#ff914d]'>React | Tailwindcss</p>
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="https://universe-parallax.netlify.app/" 
                            rel="noreferrer" target="_blank">
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
                                    Demo
                                </button>
                            </a>
                            <a href="https://github.com/RifadhRFD/react-parallax" 
                            rel="noreferrer" target="_blank">
                                <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
                                    Code
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            


            </div>


        </div>
    </div>
  )
}

export default Projects
